module.exports = __webpack_public_path__ + "img/law_32.663f25c7.jpg";